module.exports = __webpack_public_path__ + "static/media/08.eb915940.jpg";